import { UserSearch } from 'lucide-react'
import { PATHS, ROUTE_ACTIONS } from '@/app/router/routes'
import type { ErrorActionRegistry } from '@/shared/types/error-action'
import { CLIENT_DUPLICATE_CODE } from '../utils/duplicate-client-error'

/**
 * Actionable errors for the clients domain. Each entry maps a backend errorCode
 * to the actions the user can take. This is the pattern other features replicate:
 * own your error actions here and inject the registry into `useErrorHandler`.
 */
export const clientErrorActions: ErrorActionRegistry = {
  // Tried to create a client whose DPI/NIT already exists → offer a shortcut to
  // the existing record instead of a dead-end. The error is self-describing
  // (details carry existingType + existingId), so this resolver is standalone.
  [CLIENT_DUPLICATE_CODE]: ({ apiError, navigate }) => {
    const details = (apiError.details ?? {}) as {
      existingId?: string
      existingType?: string
    }
    if (!details.existingId || !details.existingType) return []

    return [
      {
        label: 'Ver cliente',
        primary: true,
        icon: UserSearch,
        onClick: () => {
          navigate(
            PATHS.admin.clients.byType(
              details.existingType!,
              ROUTE_ACTIONS.view,
              details.existingId!
            )
          )
        }
      }
    ]
  }
}
